<template>
    <div class="table-responsive visitors-table-container">
        <table
            class="person-visitors-table table table-sm table-bordered table-hover"
        >
            <caption>
                Ingresos de Vehículos
            </caption>
            <thead class="thead-orange">
                <tr>
                    <th>Visitantes</th>
                    <th>Registrado en</th>
                    <th>Propietario</th>
                    <th>Placa</th>
                    <th>Marca</th>
                    <th>Tipo Vehículo</th>
                    <th>Destino</th>
                    <th>Persona Visitada</th>
                    <!-- <th>Proposito</th> -->
                    <th>Notas</th>
                    <th>Es visitante</th>
                    <th>Tipo Ingreso</th>
                    <th>Fecha Ingreso</th>
                    <th>Fecha Salida</th>
                    <th>Duración (HH:MM:SS)</th>
                    <th>Persona que Registra</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in data"
                    :key="item.id"
                    :data-entry="item.id"
                    :id="`entry_${item.id}`"
                    class="entry-row"
                    :data-image="
                        !!item.vehicle.vehicle_photos &&
                        !!item.vehicle.vehicle_photos.length
                            ? item.vehicle.vehicle_photos[0].photo_url
                            : ''
                    "
                    :data-title="item.vehicle.plate"
                >
                    <td>
                        {{
                            item.person_entries
                                .map((pe) => pe.person.name)
                                .join(', ')
                        }}
                    </td>
                    <td>{{ item.structure.name }}</td>
                    <td>
                        {{
                            !!item.vehicle.person
                                ? item.vehicle.person.name
                                : ''
                        }}
                    </td>

                    <td :id="`name-${item.id}`">{{ item.vehicle.plate }}</td>
                    <td>{{ item.vehicle.brand }}</td>
                    <td>{{ item.vehicle.vehicle_type.name }}</td>
                    <td>{{ item.destination.name }}</td>
                    <td>
                        {{
                            !!item.visited_person
                                ? item.visited_person.name
                                : ''
                        }}
                        <b-popover
                            :target="`entry_${item.id}`"
                            triggers="hover focus"
                            v-if="
                                !!item.vehicle &&
                                !!item.vehicle.vehicle_photos.length
                            "
                        >
                            <template slot="title">
                                {{ item.vehicle.plate || '' }}
                            </template>
                            <div>
                                <b-img
                                    :src="
                                        item.vehicle.vehicle_photos[0].photo_url
                                    "
                                    style="max-width: 100%"
                                ></b-img>
                            </div>
                        </b-popover>
                    </td>
                    <!-- <td>{{ item.purpose }}</td> -->
                    <td>{{ item.notes }}</td>
                    <td>{{ item.vehicle.internal | yesno }}</td>
                    <td>{{ item.vehicle_entry_type.name }}</td>
                    <td>{{ item.created_at | datetime }}</td>
                    <td>{{ item.completed_date | datetime }}</td>
                    <td>
                        {{
                            (() => {
                                if (!item.duration) return ''
                                const duration = Number(item.duration)
                                if (isNaN(duration) || duration === 0)
                                    return '00:00:00'
                                // Suponemos que item.duration está en minutos con decimales (por ejemplo, 90.5 = 1h 30m 30s)
                                const totalSeconds = Math.round(duration * 60)
                                const hours = Math.floor(totalSeconds / 3600)
                                const minutes = Math.floor(
                                    (totalSeconds % 3600) / 60
                                )
                                const seconds = totalSeconds % 60
                                return `${hours
                                    .toString()
                                    .padStart(2, '0')}:${minutes
                                    .toString()
                                    .padStart(2, '0')}:${seconds
                                    .toString()
                                    .padStart(2, '0')}`
                            })()
                        }}
                    </td>
                    <td>{{ item.user.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
}
</script>
